import React from "react";
import InputContainer from "./InputContainer";

const MyTextField = React.forwardRef((props, ref) => {
  const {
    label,
    name,
    placeholder,
    multiline,
    rows,
    error,
    size,
    onCustomChange,
    onFileChange,
    watch,
    mode,
    setValue,
    control,
    rules,
    className = "",
    inputClassName = "",
    noSpinner,
    hideSpin,
    min,
    onKeyDown,
    ...otherProps
  } = props;

  const isNoSpinner =
    noSpinner ||
    hideSpin ||
    (typeof className === "string" && className.includes("no-spinner")) ||
    (typeof inputClassName === "string" && inputClassName.includes("no-spinner"));

  const handleKeyDown = (e) => {
    if (min !== undefined && min >= 0 && (e.key === "-" || e.key === "e" || e.key === "E")) {
      e.preventDefault();
    }
    if (onKeyDown) {
      onKeyDown(e);
    }
  };

  return (
    <InputContainer {...props} className={className} label={label} error={error} size={size}>
      <input
        ref={ref}
        type="number"
        name={name}
        placeholder={placeholder}
        min={min}
        onKeyDown={handleKeyDown}
        {...otherProps}
        className={`form-control ${inputClassName} ${isNoSpinner ? "no-spinner" : ""}`.trim()}
      />
    </InputContainer>
  );
});
export default MyTextField;



